import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const SortArrowBox = styled(Box)<{ $isActive?: boolean; $isHovered?: boolean }>`
  position: relative;
  justify-content: center;
  align-items: center;
  min-width: 18px;
  min-height: 18px;
  transition: opacity 0.2s;
  cursor: pointer;
  display: inline-flex;
  opacity: ${({ $isActive, $isHovered }) => ($isActive || $isHovered ? '1' : '0')};
  color: ${colors.backgroundGrey};
`
